<template>
  <!-- 店铺数据 -->
  <div class="shop-data">
    <!-- -->
    <div class="block">
      <div class="block-content" v-for="(item, index) in listArr" :key="index">
        <p class="title">{{ item.title }}</p>
        <p class="note">{{ item.note }}</p>
        <p class="quantity">{{ item.quantity }}</p>
        <p class="Compare">{{ item.Compare }}</p>
      </div>
    </div>
    <!-- 趋势图 -->
    <div class="tendency">
      <p class="title">趋势图</p>
      <p class="note">(商品总成交量)</p>
      <div class="Toggle">
        <p class="firm-clickable"
          v-for="(item, index) in cycleArr"
          :key="index"
          :style="cycle == item.id ? 'background: #409eff ;color:#ffffff' : ''"
          @click="cycle = item.id"
        >
          {{ item.name }}
        </p>
      </div>
    </div>
    <div class="LineChart">
      <lineBar
        :barName="barName"
        :barVal1="barVal1"
        :blo="1"
        :typeList="typeList"
      ></lineBar>
      <!-- typeList 鼠标悬停某点 前面的名称 后面跟的是该点的值 -->
    </div>
  </div>
</template>

<script>
import lineBar from "./components/lineBar.vue";
export default {
  data() {
    return {
      listArr: [
        {
          title: "商品总成交量",
          note: "（本店商品+招标商品，已完结）",
          quantity: "66",
          Compare: "+6",
        },
        {
          title: "进行中",
          note: "（本店商品+招标商品）",
          quantity: "66",
          Compare: "-6",
        },
        {
          title: "总营收金额",
          note: "（可提现金额+已提现金额）",
          quantity: "623,356",
          Compare: "+6",
        },
        {
          title: "中标数",
          note: "（统计中标的外包项目）",
          quantity: "66",
          Compare: "+6",
        },
        {
          title: "支出金额",
          note: "（作为雇主支出服务商金额）",
          quantity: "66",
          Compare: "+6",
        },
      ], //各个数量
      cycleArr: [
        {
          name: "近1周",
          id: "1",
        },
        {
          name: "近4周",
          id: "2",
        },
        {
          name: "近12周",
          id: "3",
        },
      ], //周期选择
      cycle: "1",
      barName: [
        "12-06",
        "12-07",
        "12-08",
        "12-09",
        "12-10",
        "12-11",
        "12-12",
        "12-13",
      ],
      barVal1: [20, 10, 15, 25, 30, 15, 30, 35, 40],
      typeList: [""],
    };
  },
  watch: {},
  components: {
    lineBar,
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.shop-data {
  width: 100%;
  height: 100%;
  .block {
    width: 100%;
    height: 290px;
    display: flex;
    flex-wrap: wrap;
    .block-content:nth-child(4) {
      margin-right: 0px;
    }
    .block-content:hover {
      box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
    }
    .block-content {
      width: 220px;
      height: 90px;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
      border-radius: 10px;
      padding: 15px 20px 20px 20px;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      margin-right: 16px;
      .title {
        width: 100%;
        height: 18px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 7px;
      }
      .note {
        height: 14px;
        font-size: 12px;
        color: #666666;
        margin-bottom: 15px;
      }
      .quantity {
        width: 100%;
        height: 18px;
        font-size: 14px;
        color: #fe574a;
        text-align: right;
        margin-bottom: 10px;
      }
      .Compare {
        width: 100%;
        height: 14px;
        font-size: 12px;
        color: #999999;
        text-align: right;
      }
    }
  }
  // 趋势图
  .tendency {
    width: 100%;
    height: 25px;
    line-height: 25px;
    margin-top: 30px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    margin-bottom: 20px;
    .title {
      min-width: 50px;
      font-size: 16px;
      color: #333333;
    }
    .note {
      min-width: 130px;
      font-size: 16px;
      color: #999999;
      margin-left: 10px;
    }
    .Toggle {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      p {
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #666666;
        text-align: center;
        font-weight: 400;
        width: 60px;
        height: 25px;
        line-height: 25px;
      }
      p:nth-child(1) {
        border: 1px solid #409eff ;
        border-radius: 10px 0px 0px 10px;
      }
      p:nth-child(2) {
        border-top: 1px solid #409eff ;
        border-bottom: 1px solid #409eff ;
      }
      p:nth-child(3) {
        border: 1px solid #409eff ;
        border-radius: 0px 10px 10px 0px;
      }
    }
  }
  .LineChart {
    width: 100%;
    height: 250px;
  }
}
</style>
